import React from "react";
import EducationCard from "./Education-Card/EducationCard";
import EducationData from "data/education.json";
import "./Education.scss";

const Education = () => {
  const educationDataWithId = EducationData.map((data, index) => ({
    id: index + 1,
    ...data,
  }));

  return (
    <section id="education">
      <div className="container mb-5">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="education-list">
              {educationDataWithId.map((study) => (
                <EducationCard
                  key={study.id}
                  year={study.year}
                  field={study.field}
                  college={study.college}
                  description={study.description}
                  img={study.img}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
